<template>
	<div v-if="hasDelete">
		<v-layout>
			<v-flex :xs12="header == ''" :xs9="header != ''">
				<p class="row-label" style="">
					<v-dialog v-model="dialog" persistent max-width="500">
						<!--<template v-slot:activator="{ on }">
							<v-btn
								style="margin:0px !important;"
								class="ma-2"
								text
								icon
								color="red darken-4"
								v-on="on"
							>
								<v-icon small>mdi-delete</v-icon>
							</v-btn>
						</template>-->
						<v-card>
							<v-card-title v-if="header != ''" class="headline red--text text--darken-2">Remove Organization {{ header }}?</v-card-title>
							<v-card-title v-else class="headline red--text text--darken-2">Remove {{ label }}?</v-card-title>
							<v-card-text v-if="header != ''" class="black--text text-left">
								<!-- <p>Are you sure you want to remove <b>{{ label }}</b>?</p> -->
								<p><b>{{ label }}</b></p>
								<p>Data entered for this row will be permanently deleted.</p></v-card-text>
								<v-card-text v-else class="black--text text-left">
								<p>Data entered for this row will be permanently deleted.</p></v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text @click="dialog = false">Cancel</v-btn>
								<v-btn color="red darken-2" text @click="deleteRow($event)">Delete</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					{{ label }}
				</p>
			</v-flex>
			<v-flex  v-if="header != ''" xs3>
				<p class="row-label" style="text-align: center; margin-top: 8px">{{ header }}</p>
			</v-flex>
			<v-flex xs3>
				<p class="row-label" style="text-align: center; margin-top: 8px">{{ state }}</p>
			</v-flex>
		</v-layout>
	</div>

	<div v-else-if="!isSub">
		<p class="row-label"><span v-if="header !=''">{{ header }} </span>{{ label }}</p>
		<p v-if="help != ''" v-html="help" class="row-label-help"></p>
	</div>
	<div v-else>
		<p class="row-label-sub">{{ header }}. {{ label }} </p>
		<p v-if="help != ''" v-html="help" class="row-label-help"></p>
	</div>

</template>

<script>
export default {
  name: "HeaderCell",
  props: {
    cellId: String,
    answerId: String,
    questionId: String,
    question: Object,
    header: String,
    label: String,
		isSub: Boolean,
		help: String,
		hasDelete: Boolean,
		state: String
  },
	data: () => ({
		dialog: false
	}),
	methods: {
		deleteRow: function (evt) {
			this.dialog = false;
			this.$emit('delete', {});
		}
	}
};
</script>

<style scoped>
.row-label {
  /*GBC line-height: 48px;*/
  font-weight: bold;
  text-align: left;
}
.row-label-sub {
  font-weight: normal;
  text-align: left;
  margin-top: 10px;
  margin-left: 5%;
}
.row-label-help {
  font-weight: normal;
  text-align: left;
  margin-left: 25px;
}

.row-label p {
	text-align: left;
}

</style>
